'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || '登入失敗');
      }
      router.push('/');
      router.refresh();
    } catch (err) {
      setError(err instanceof Error ? err.message : '登入失敗，請再試一次');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen bg-ground flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="mx-auto mb-3 flex items-center justify-center w-11 h-11 rounded-xl bg-accent text-accent-ink text-xl font-bold">
            H
          </div>
          <div className="text-xl font-semibold text-ink tracking-tight">HTX Base</div>
          <div className="text-sm text-ink-soft mt-1">內部文件系統</div>
        </div>

        <div className="bg-panel rounded-xl border border-line shadow-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-ink mb-1.5">帳號</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full rounded-lg border border-line-strong bg-panel px-3.5 py-2.5 text-ink focus:outline-none focus:ring-2 focus:ring-accent/40 focus:border-accent transition-colors"
                autoFocus
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-ink mb-1.5">密碼</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-line-strong bg-panel px-3.5 py-2.5 text-ink focus:outline-none focus:ring-2 focus:ring-accent/40 focus:border-accent transition-colors"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-accent text-accent-ink py-2.5 font-medium hover:bg-accent-hover disabled:opacity-50 transition-colors"
            >
              {loading ? '登入中...' : '登入'}
            </button>

            {error && (
              <div className="rounded-lg bg-danger-soft border border-danger/20 px-4 py-2.5 text-sm text-danger">
                {error}
              </div>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}
